import { Component } from '@angular/core';
import { WatchFunnelService } from '../../../../services/watch-funnel.service';
import { FunnelService } from '../../../../services/funnel.service';
import { IFunnel } from '../../../../interfaces/graph-types';

@Component({
  selector: '[account-funnel-resources]',
  template: require('./account-funnel-resources.component.pug'),
  styles: [require('./account-funnel-resources.component.css').toString()],
})
export class AccountFunnelResourcesComponent {
  // -------------------------------------------------------------------
  constructor(
    private watchFunnel: WatchFunnelService,
    private funnelService: FunnelService,
  ) {}

  funnel: IFunnel;

  // -------------------------------------------------------------------
  ngOnInit(): void {}

  // -------------------------------------------------------------------
  ngOnDestroy() {}
}
